export const ACCOUNT_TYPE_CONSUMER = 2;
export const ACCOUNT_TYPE_VOLUNTEER = 1;


// WEBPACK FOOTER //
// ./src/modules/shared/constants.js